export default "__VITE_ASSET__Cbudib2R__"